import MyProfile from "../../../jsx/components/Dashboard/MyProfile/myprofile";

const MyProfileWrapper = () => {
  return <MyProfile />;
};

export default constore(MyProfileWrapper);
